module.exports = __webpack_public_path__ + "img/guide-banner.a0146466.png";